var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('div',{staticClass:"app-avatar",style:({ 'font-size': _vm.size / 2 + 'px' })},[_c('v-avatar',{attrs:{"size":_vm.size,"color":_vm.colorAvatar}},[(_vm.avatarSrc)?_c('img',{attrs:{"src":_vm.avatarSrc}}):_c('div',[_vm._v(" "+_vm._s(_vm.letter)+" ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }